import api from "../store/services/api";

export const getFiscalTicketHistory = (params) =>
  api.get("/orders/fiscal/history/", { params });

export const getFiscalInfo = (fiscal_id) =>
  api.get("/fiscal/", { params: { fid: fiscal_id } });

export const getOrderFiscal = (order_id, type = undefined) =>
  api.get("/orders/fiscal/", {
    params: { orderId: order_id, type: type },
  });

export const getFiscalTicketDANFE = (danfe_path) =>
  api.get("/fiscal/danfe", { params: { path: danfe_path } });

export const generateFiscalNFCE = (fiscal) =>
  api.post("/orders/fiscal/new/nfce/?usev2=true", fiscal, {
    headers: { "Content-Type": "application/json" },
  });

export const generateFiscalNFE = (fiscal) =>
  api.post("/orders/fiscal/new/nfe/", fiscal, {
    headers: { "Content-Type": "application/json" },
  });

export const getNFEStatus = (ref) =>
  api.get("/orders/fiscal/status/nfe/", { params: { ref: ref } });

export const registerCompany = (company) =>
  api.post("/delivery-center/fiscal/company/", company, {
    headers: { "Content-Type": "application/json" },
  });

export const alterCompany = (companyId, company) =>
  api.put(`/delivery-center/fiscal/company/?id=${companyId}`, company, {
    headers: { "Content-Type": "application/json" },
  });

export const registerMerchantCompany = (company) =>
  api.post("/merchant/fiscal/company/", company, {
    headers: { "Content-Type": "application/json" },
  });

export const alterMerchantCompany = (companyId, company) =>
  api.put(`/merchant/fiscal/company/?id=${companyId}`, company, {
    headers: { "Content-Type": "application/json" },
  });

export const cancelFiscalTicket = (params) =>
  api.delete(`/fiscal/cancel/`, { params });

export const downloadFiscalBackup = (year, month) =>
  api.get("/orders/fiscal/backup/", { params: { year, month } });

const FiscalService = {
  getFiscalTicketHistory,
  getFiscalInfo,
  getOrderFiscal,
  getFiscalTicketDANFE,
  generateFiscalNFCE,
  generateFiscalNFE,
  getNFEStatus,
  registerCompany,
  alterCompany,
  registerMerchantCompany,
  alterMerchantCompany,
  cancelFiscalTicket,
  downloadFiscalBackup,
};

export default FiscalService;
